<template>
    <v-card>
        <v-card-title class="headline">
            {{ $i18n.t('editTestTitle' )}}

            <v-spacer/>

            <v-btn @click="$store.commit('setEditTestDialog', false)">
                {{ $t('cancel') }}
                <v-icon right>clear</v-icon>
            </v-btn>
            <v-btn @click="submit" class="ml-7" color="teal">
                {{ $t('save') }}
                <v-icon right>done</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text>
            <v-container grid-list-xl>
                <v-form ref="form" @submit="submit">
                    <v-text-field dense v-model="title" :rules="titleRules" :placeholder="getTest.title" :label="$i18n.t('title')">
                        <v-tooltip slot="append" v-if="title != getTest.title" bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" @click="title = getTest.title">replay</v-icon>
                            </template>
                            <span>{{ $t('undo') }}</span>
                        </v-tooltip>
                    </v-text-field>
                </v-form>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { i18n } from '@/main.js' 

export default {
    data(){
        return {
            titleRules: [
                v => !!v || i18n.t('noTitle'),
                v => !v || v.length <= 200 || i18n.t('longTitle'),
            ],
        }
    },

    methods: {
        submit() {
            if (this.$refs.form.validate())
                this.$store.dispatch('updateTest')
        },
    },

    computed: {
        ...mapGetters([
            'isLoading',
            'getTest',
            'getTestTitle',
        ]),
        title: {
            get() { return this.getTestTitle },
            set(value) { this.$store.commit('setTestTitle', value) },
        },
    },
}
</script>